/** Skill görsel efekt sprite boyutları (karakter 100×100 üzerine ortalanır) */
export const SKILL_EFFECT_FRAME_WIDTH = 300;
export const SKILL_EFFECT_FRAME_HEIGHT = 150;
export const SKILL_EFFECT_FRAME_COUNT = 5;
export const DEFAULT_SKILL_EFFECT_FPS = 5;
